import { gql, useMutation } from "@apollo/client";
import { Status } from "../../types";

interface EditProtocolMutationVariables {
  id: string;
  name?: string;
  description?: string;
  status?: Status;
}

const editProtocolMutation = gql`
  mutation EditProtocol($id: ID!, $name: String, $description: String, $status: ProtocolStatus) {
    editProtocol(id: $id, name: $name, description: $description, status: $status) {
      id
    }
  }
`;

export const useEditProtocol = () => {
  return useMutation<{ id: string }, EditProtocolMutationVariables>(editProtocolMutation, {
    refetchQueries: ["protocols", "allProtocols", "protocol"],
  });
};
